module.exports = __webpack_public_path__ + "img/m-yusuanguanli.a1d2702a.svg";